export default "__VITE_ASSET__DsoBLV5O__"